<template>
  <div v-if="meetingStore.showMeetingLink">
    <p>10 am to approximately 12 pm</p>
    <br />
    <p>
      <a class="link" :href="meetingStore.meetingLink" target="_blank">
        Click here to join the meeting
      </a>
    </p>
    <br />
    <p style="color: red;">Please mute your microphone upon joining.</p>
    <div v-if="meetingStore.showMeetingVideo && meetingStore.meetingVideoId">
      <hr />
      <div class="video">
        <iframe
          width="640"
          :height="height"
          :src="`https://www.youtube.com/embed/${meetingStore.meetingVideoId}`"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
    </div>
    <hr />
  </div>
</template>

<script setup>
import { useMeetingStore } from '@/stores/meeting'
const meetingStore = useMeetingStore()
const height = 380
</script>

<style scoped>
.link {
  font-size: 20px;
  font-weight: 700;
}
</style>
